import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { GeneralCurrency } from '@gs-2.0/core';
import { TranslatePipe } from '../../pipes/translate.pipe';

/**
 * Filter type for search results
 */
export type SearchFilterType = 'everything' | 'project' | 'organization';

/**
 * Data passed to the search filters bottom sheet
 */
export interface SearchFiltersBottomSheetData {
  activeFilterType: SearchFilterType;
  currencies: GeneralCurrency[];
  selectedCurrency: GeneralCurrency | null;
}

/**
 * Result returned when bottom sheet is dismissed
 */
export interface SearchFiltersBottomSheetResult {
  filterType: SearchFilterType;
  currency: GeneralCurrency | null;
}

/**
 * Search filters bottom sheet component - for mobile view
 * Shows simple filter options for search results (Everything/Project/Organization + Currency)
 */
@Component({
  selector: 'app-search-filters-bottom-sheet',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './search-filters-bottom-sheet.component.html',
  styleUrls: ['./search-filters-bottom-sheet.component.scss'],
})
export class SearchFiltersBottomSheetComponent implements OnInit {
  activeFilterType: SearchFilterType;
  currencies: GeneralCurrency[];
  selectedCurrency: GeneralCurrency | null;
  isCurrencyDropdownOpen = false;

  constructor(
    private bottomSheetRef: MatBottomSheetRef<SearchFiltersBottomSheetComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: SearchFiltersBottomSheetData,
    private cdr: ChangeDetectorRef
  ) {
    this.activeFilterType = data.activeFilterType;
    this.currencies = data.currencies;
    this.selectedCurrency = data.selectedCurrency;
  }

  ngOnInit(): void {
    // Component initialization
  }

  /**
   * Handle filter type change
   */
  onFilterTypeChange(filterType: SearchFilterType): void {
    this.activeFilterType = filterType;
    this.cdr.detectChanges();
  }

  /**
   * Toggle currency dropdown
   */
  toggleCurrencyDropdown(): void {
    this.isCurrencyDropdownOpen = !this.isCurrencyDropdownOpen;
  }

  /**
   * Handle currency selection
   */
  onCurrencySelect(currency: GeneralCurrency): void {
    this.selectedCurrency = currency;
    this.isCurrencyDropdownOpen = false;
  }

  /**
   * Close currency dropdown
   */
  closeCurrencyDropdown(): void {
    this.isCurrencyDropdownOpen = false;
  }

  /**
   * Apply filters and close bottom sheet
   */
  applyFilters(): void {
    const result: SearchFiltersBottomSheetResult = {
      filterType: this.activeFilterType,
      currency: this.selectedCurrency,
    };
    this.bottomSheetRef.dismiss(result);
  }

  /**
   * Close bottom sheet without applying
   */
  close(): void {
    this.bottomSheetRef.dismiss();
  }
}
